import { ICurrentUser } from '../../App/store/features/person/interface/ICurrentUser'
import { IEstablishment } from '../../Establishment/interface/IEstablishment'

interface ICompanyDetails {
  companyId: string
  name: string
}

export interface IIntercomBootDetails {
  name: string
  email: string
  userId: string
  company: ICompanyDetails
}

export const intercomBootDetails = (
  establishment: IEstablishment,
  currentUser: ICurrentUser,
): IIntercomBootDetails => ({
  name: `${currentUser.firstName} ${currentUser.lastName}`,
  userId: currentUser.id.toString(),
  email: currentUser.email,
  company: {
    companyId: establishment.id.toString(),
    name: establishment.name,
  },
})
